module.exports = __webpack_public_path__ + "static/media/lock.2b3cf0c2.svg";